import styled from 'styled-components';
// import GreetingSection from '../../components/navbar/GreetingSection';
import { useTranslation } from 'react-i18next';
import '../SupportPageStyle.less';
import { Row, Col } from 'antd';
import { Button } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import GreetingSection from '../../../components/navbar/GreetingSection';
// import './index.less';
// import { InboxHeader } from './components/header';
import { Faqlist } from './components/Faqlist';
// import { useState } from 'react';
// const LifePageContainer = styled.div`
//   margin: 0;
//   dispay: flex;
// `;

export interface itemList {
  answer: string;
  category: string;
  orderId: number;
  question: string;
}

const FAQpageContainer = styled.div`
  margin: 0;
`;

interface LocationState {
  title: string;
  listData: itemList[]; // 根据你的实际情况修改类型
  listDatazh: itemList[];
}

export const LifeFaqDetailsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { title, listData, listDatazh } = location.state as LocationState;

  if (!title || !listData || !listDatazh) {
    return <div>Loading...</div>;
  }
  console.log('props===============================', location.state);
  const TodetaileEven = (v: string) => {
    if (v == 'contactUs') {
      navigate('/ContactUs');
    }
  };

  return (
    <FAQpageContainer className="FAQ">
      <GreetingSection pageName={t('life.questions.title')} showicon={false} />
      <Row justify="center" gutter={[0, { xs: 8, sm: 8, lg: 24 }]}>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 20 }}
          lg={{ span: 24 }}
          style={{
            background: '#fff',
            maxWidth: '1384px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          className="centerlist"
        >
          <Faqlist data={{ title: title, list: listData, listzh: listDatazh }} />
        </Col>
      </Row>
      <Row justify="center" gutter={[0, { xs: 8, sm: 8, lg: 24 }]}>
        <Col
          xs={{ span: 24 }}
          sm={{ span: 20 }}
          lg={{ span: 24 }}
          style={{
            background: '#fff',
            maxWidth: '1384px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          className="centerlist2"
        >
          <div
            className="header2"
            style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100%' }}
          >
            <div className="headertittle"> {t('questions.contactGenerali')}</div>
          </div>
          <div
            className="buttondiv"
            style={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center' }}
          >
            <Button
              block
              className="button"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                TodetaileEven('contactUs');
              }}
            >
              {t('questions.contactText')}
            </Button>
          </div>
        </Col>
      </Row>
    </FAQpageContainer>
  );
};
